import gql from 'graphql-tag';

export const removeFeedItemMutation = gql`
  mutation removeFeedItem($itemId: String!) {
    removeFeedItem(itemId: $itemId)
  }
`;
